import React, { useState } from "react";
import { Modal, Form } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { startReportPerson } from "../../../redux/action/chat/ClientChat";
import ErrorMessage from "../../common/ErrorMessage";
import Loader from "../../common/Loader";

function ReportPerson({ setShowReport, showReport, startChatUserDetails }) {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [reportReason, setReportReason] = useState("");
  const [reportDescription, setReportDescription] = useState("");
  const [error, setError] = useState("");

  const handleReportJob = (e) => {
    if (reportReason !== "") {
      if (reportReason === "Other" && reportDescription === "") {
        setError("Please Explain Your Reason For Reporting This person");
      } else {
        setError("");
        const data = {
          reason: reportReason,
          description: reportDescription,
          report_to:
            startChatUserDetails &&
            startChatUserDetails.user &&
            startChatUserDetails.user.id,
        };
        dispatch(startReportPerson(data, setLoading, setError, setShowReport));
      }
    } else {
      setError("Please select any reason to report this person");
    }
  };
  return (
    <div>
      <Modal
        show={showReport}
        size="lg"
        onHide={() => setShowReport(false)}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Body>
          <p className="common-heading-Medium md-font text-dark-black mb-0">
            Report Person
          </p>
          <div className="border-bottom my-3"></div>
          {error !== "" ? <ErrorMessage message={error} /> : ""}

          <div className=" mt-2">
            <div className="row  flex-sm-row  flex-column">
              <div className="col-auto my-sm-0 my-3  pe-sm-0">
                <button
                  className={`${
                    reportReason === "Inappropriate"
                      ? "atech-popup-button-active w-100 py-2 px-4"
                      : "atech-popup-button w-100 py-2 px-4"
                  }`}
                  onClick={() => setReportReason("Inappropriate")}
                >
                  Inappropriate
                </button>
              </div>
              <div className="col-auto  pe-sm-0">
                <button
                  className={`${
                    reportReason === "Fake Job"
                      ? "atech-popup-button-active w-100 py-2 px-4"
                      : "atech-popup-button w-100 py-2 px-4"
                  }`}
                  onClick={() => setReportReason("Fake Job")}
                >
                  Fake Job
                </button>
              </div>
              <div className="col-auto  pe-sm-0">
                <button
                  className={`${
                    reportReason === "Abuse"
                      ? "atech-popup-button-active w-100 py-2 px-4"
                      : "atech-popup-button w-100 py-2 px-4"
                  }`}
                  onClick={() => setReportReason("Abuse")}
                >
                  Abuse
                </button>
              </div>
              <div className="col-auto  pe-sm-0">
                <button
                  className={`${
                    reportReason === "Other"
                      ? "atech-popup-button-active w-100 py-2 px-4"
                      : "atech-popup-button w-100 py-2 px-4"
                  }`}
                  onClick={() => setReportReason("Other")}
                >
                  Other
                </button>
              </div>
            </div>
          </div>
          <div className="mt-4 mb-3">
            <Form.Group
              className=" textarea-focus"
              controlId="exampleForm.ControlTextarea1"
            >
              <Form.Control
                placeholder="Explain your report"
                as="textarea"
                rows={5}
                disabled={reportReason === "Other" ? false : true}
                onChange={(e) => setReportDescription(e.target.value)}
              />
            </Form.Group>
          </div>

          <div className="d-flex flex-sm-row  flex-column mt-3">
            <button
              className="px-4 atech-primary-button  py-sm-2 py-2 ms-sm-2  my-2"
              onClick={() => handleReportJob()}
              disabled={loading}
            >
              {loading ? <Loader /> : "Report"}
            </button>
            <button
              className="px-4  py-sm-2 py-2 ms-sm-2  my-2  atech-fade-button"
              onClick={() => setShowReport(false)}
            >
              Cancel
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default ReportPerson;
